import { useEffect, useState, useRef } from 'react';
import { getSignedUrl } from '../../server';
import styled from 'styled-components'

const ThumbnailWrapper = styled.div`
  aspect-ratio: 4 / 3;
  border-radius: 4px;
  overflow: hidden;
  cursor: pointer;
  border: 2px solid ${props => props.selected ? '#004fff' : 'transparent'};
  opacity: ${props => props.selected ? 1 : 0.6};
  transition: all 0.2s;
  background: #eee;
  position: relative;

  &:hover {
    opacity: 1;
  }

  img, video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const PlayIcon = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #333;
  color: white;
  font-size: 2em;
`;

export default function Thumbnail({ filename, selected, onClick }) {
  const [url, setUrl] = useState(null);
  const wrapperRef = useRef(null);
  const isVideo = filename.includes('.mp4');

  useEffect(() => {
    if (isVideo) return;

    let active = true;
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          getSignedUrl("thumb_" + filename)
            .then((u) => {
              if (active) setUrl(u);
            })
            .catch((err) => console.error("Thumbnail load error", err));
          observer.disconnect();
        }
      },
      { rootMargin: "200px" }
    );

    if (wrapperRef.current) observer.observe(wrapperRef.current);

    return () => {
      active = false;
      observer.disconnect();
    };
  }, [filename, isVideo]);

  return (
    <ThumbnailWrapper ref={wrapperRef} selected={selected} onClick={onClick}>
      {isVideo ? (
        <PlayIcon>▶</PlayIcon>
      ) : (
        url && <img src={url} alt={filename} loading="lazy" />
      )}
    </ThumbnailWrapper>
  );
}